
import React from 'react';

import './sidebar.css'
import SidebarHeader from './SidebarHeader';
import SidebarContents from './SidebarContents';
import { useShared } from "../../hooks/useShared";
export default function SideBar(props) {

   const { pushSideBar } = useShared();
    return (
        <aside className={`hidden md:block md:shadow transform -translate-x-full md:translate-x-0 transition-full duration-300 ease-in bg-red-900 
        text-main-color  ${!pushSideBar ? " md:translate-x-0 md:!w-[220px]" : "md:-translate-x-0 md:w-[80px]"}` }>
           <SidebarHeader />
           <SidebarContents />
           <div className='text-center p-2 h-[2vh] text-blue-gray-200 text-xs'>ACMEG DB v1.0.0</div>
        </aside>
    )  
}; 